import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=12ff67e8"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports